export function createDeptUrl(deptUrl: string) {
  const isUrlV2 = deptUrl.includes('UmangVersion2');
  const isUrlDeptt = deptUrl.includes('deptt');

  if (isUrlV2 || isUrlDeptt) {
    const protocol = deptUrl.includes('http://') ? 'http://' : 'https://';
    const urlWithoutProtocol = deptUrl.split(protocol)[1];
    return urlWithoutProtocol.slice(urlWithoutProtocol.indexOf('/') + 1);
  }

  const deptUrlSplits = deptUrl.split('/') as string[];
  const isDEPTUrl = deptUrl.includes('dept/');

  return `${isDEPTUrl ? `dept/${deptUrlSplits[4]}` : ''}${
    deptUrlSplits[deptUrlSplits.length - (isDEPTUrl ? 1 : 2)]
  }`;
}
